import React from "react";
import SubHeader from "../../components/common/topHeader/subHeader";
import DeviceConnected from "../devices/deviceConnected";
import DeviceAlerts from "../devices/deviceAlerts";
import DevicePageInlet from '../devices/deviceInlets';
import DeviceOutlets from './deviceOutlets';
import DeviceSensors from './deviceSensors';
import LoggingEventLogs from "../logging/eventLogs";
import LoggingUserLogs from "../logging/userLogs";

import axios from "axios";
import NotificationManager from "../../utils/notificationManager";
import { getThemeColors, getPillColors } from "../../utils/theme";
// import ModalManager from '../../componentscommon/modal/ModalManager
import ModelManager from "../../components/common/modal/ModalManager";
import TextInput from "../../components/common/inputs/textInput";
import ToggleInput from "../../components/common/inputs/toggleInput";
import SelectInput from "../../components/common/inputs/selectInput";
import Loading from "../../components/common/loading";
import Pagination from "../../components/common/pagination";
import { Link } from "react-router-dom";

import { Switch, Route, Redirect } from "react-router-dom";
import ModalManager from "../../components/common/modal/ModalManager";

import "./deviceGroupSettings.css";

export default class DeviceGroupPage extends React.Component {
  componentDidMount() {
    this.ensureGroupsLoaded();
    // this.props.fetchResourcePaginate("devices", undefined, { page: 1, groupId: this.props.match.params.groupId }, true);
    // fetch resource paginate with group id
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.resources.groupsLoaded !== this.props.resources.groupsLoaded &&
      !this.props.resources.groupsLoaded &&
      !this.props.resources.groupsLoading
    ) {
      this.ensureGroupsLoaded();
    }
  }

  ensureGroupsLoaded = () => {
    const { resources = {}, fetchResource } = this.props;
    if (!resources.groupsLoaded && !resources.groupsLoading) {
      fetchResource("groups");
    }
  };

  render() {
    const foundGroup = this.props.resources.groups.find(
      (g) => g.id == this.props.match.params.groupId
    );
    const newGroup = this.props.match.params.groupId === "new";
    const isAdmin = this.props.user.is_enterprise_admin || this.props.user.has_admin_privileges;
    const sections = [
      {
        label: "Devices",
        icon: "power",
        path: `/devices/groups/${this.props.match.params.groupId}/devices`,
        props: {
          ...this.props,
          ignoreCache: true,
          addGroupDeviceActive: true,
          queryParams: {
            groupId: this.props.match.params.groupId,
          }
        },
        component: DeviceConnected,
      },
      {
        label: "Power Consumption",
        icon: "power",
        path: `/devices/groups/${this.props.match.params.groupId}/inlets`,
        props: {
          ...this.props,

          queryParams: {
            groupId: this.props.match.params.groupId,
          }
        },
        disabled: this.props.user.role && !this.props.user.role.viewInletInfo,
        component: DevicePageInlet
      },
      {
        label: "Manage Outlets",
        icon: "outlet",
        path: `/devices/groups/${this.props.match.params.groupId}/outlets`,
        props: {
          ...this.props,
            queryParams: {
              groupId: this.props.match.params.groupId,
            },
          resources: {
            ...this.props.resources,
          },
          hideGroupInputs: true,
        },
        disabled: this.props.user.role && !this.props.user.role.viewOutletInfo,
        component: DeviceOutlets,
      },
      {
        label: "Alerts",
        icon: "notifications",
        path: `/devices/groups/${this.props.match.params.groupId}/alerts`,
        props: {
          ...this.props,
          queryParams: {
            groupId: this.props.match.params.groupId,
          }
        },
        component: DeviceAlerts,
        disabled: this.props.user.role && !this.props.user.role.viewEventInfo,
      },
      {
        label: "Event Logs",
        icon: "notifications",
        path: `/devices/groups/${this.props.match.params.groupId}/event-logs`,
        props: {
          ...this.props,
          queryParams: {
            groupId: this.props.match.params.groupId,
          },
        },
        component: LoggingEventLogs,
        disabled: this.props.user.role && !this.props.user.role.viewEventInfo,
      },
      {
        label: "Activity Log",
        icon: "history",
        path: `/devices/groups/${this.props.match.params.groupId}/activity-log`,
        props: {
          ...this.props,
          queryParams: {
            groupId: this.props.match.params.groupId,
          },
        },
        component: LoggingUserLogs,
        disabled: this.props.user.role && !this.props.user.role.viewActivityLog,
      },
      {
        label: "Sensors",
        icon: "device_thermostat",
        path: `/devices/groups/${this.props.match.params.groupId}/sensors`,
        props: {
          ...this.props,
          resources: {
            ...this.props.resources,
            sensors: this.props.resources.sensors.filter((s) =>
              foundGroup?.items.includes(s.enclosureSerialNumber.toString())
            ),
          },
        },
        component: DeviceSensors,
        disabled: this.props.user.role && !this.props.user.role.viewSensorInfo,
      },
      {
        label: "Users",
        icon: "group",
        path: `/devices/groups/${this.props.match.params.groupId}/users`,
        props: {
          ...this.props,
        },
        disabled: !isAdmin ,
        component: GroupUsers,
      },
      {
        label: "Settings",
        icon: "settings",
        path: `/devices/groups/${this.props.match.params.groupId}/settings`,
        props: {
          ...this.props,
        },
        disabled: !isAdmin && this.props.user.enterprise_Id,
        component:
          this.props.resources.groupsLoading ? Loading : GroupSettings,
      },
      {
        label: "Privileges",
        icon: "lock",
        path: `/devices/groups/${this.props.match.params.groupId}/privileges`,
        disabled: !isAdmin,
        props: {
          ...this.props,
        },
        component: GroupPrivileges,
      },
    ];
    return (
      <div>
        {!newGroup && (
          <SubHeader
            sections={sections.filter((section) => !section.disabled)}
          />
        )}
        <div
          style={{
            marginLeft: "15px",
            marginRight: "15px",
            paddingTop: "20px",
            borderBottom: "solid #ddd 1px",
          }}
        >
          <h5>{foundGroup?.name}</h5>
        </div>
        <Switch>
          {sections &&
            sections.map((section) => {
              return (
                <Route
                  key={section.label}
                  path={section.path}
                  exact={section.exact}
                  render={(props) => {
                    // const CompToRender = scrollTopOnMount(section.component);
                    const CompToRender = section.component;
                    return (
                      <CompToRender
                        {...(section.props || {})}
                        match={this.props.match}
                      />
                    );
                  }}
                />
              );
            })}
          {sections && (
            <Redirect
              exact
              to={
                newGroup
                  ? `/devices/groups/new/settings`
                  : `/devices/groups/${this.props.match.params.groupId}/devices`
              }
            />
          )}
        </Switch>
      </div>
    );
  }
}

class GroupUsers extends React.Component {
  state = {
    searchTerm: "",
    addUserModalOpen: false,
    addUserMode: "existing",
    existingUserSearch: "",
    selectedExistingUserId: null,
    modalSubmitting: false,
    modalError: "",
    inviteEmail: "",
    inviteHasAdminPrivileges: false,
    invitePasswordLoginDisabled: false,
    usersPager: null,
    usersPageItems: [],
    dark: typeof document !== "undefined" &&
      document.body.classList.contains("dark-mode"),
  };

  componentDidMount() {
    if (
      !this.props.resources.userEnterpriseLoaded &&
      !this.props.resources.userEnterpriseLoading
    ) {
      this.props.fetchResource("userEnterprise");
    }
    if (typeof document !== "undefined") {
      this.darkObserver = new MutationObserver(() => {
        const isDark = document.body.classList.contains("dark-mode");
        this.setState((prev) => (prev.dark === isDark ? null : { dark: isDark }));
      });
      this.darkObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  componentWillUnmount() {
    if (this.darkObserver) {
      this.darkObserver.disconnect();
    }
  }
  getUserIdentifier = (user = {}) => {
    return user.id || user.user_id || user.email_id;
  };

  getGroupDevices = () => {
    const foundGroup = this.props.resources.groups.find(
      (g) => g.id == this.props.match.params.groupId
    );
    if (!foundGroup || !Array.isArray(foundGroup.items)) {
      return [];
    }
    const deviceIds = new Set(
      foundGroup.items.map((item) =>
        typeof item === "string" ? item : item?.toString?.() || `${item}`
      )
    );
    const devices = this.props.resources.devices || [];
    return devices.filter((device) => {
      const serial =
        typeof device.enclosureSerialNumber === "string"
          ? device.enclosureSerialNumber
          : device.enclosureSerialNumber?.toString?.() ||
            `${device.enclosureSerialNumber}`;
      return deviceIds.has(serial);
    });
  };

  getAvailableEnterpriseUsers = () => {
    const foundGroup = this.props.resources.groups.find(
      (g) => g.id == this.props.match.params.groupId
    );
    const currentUsers = foundGroup?.users || [];
    const assignedIds = new Set(
      currentUsers.map((user) => this.getUserIdentifier(user))
    );
    const enterpriseUsers =
      this.props.resources.userEnterprise?.users || [];
    return enterpriseUsers
      .filter((user) => !assignedIds.has(this.getUserIdentifier(user)))
      .sort((a, b) => {
        const aName = (a.full_name || a.display_name || a.email_id || "").toLowerCase();
        const bName = (b.full_name || b.display_name || b.email_id || "").toLowerCase();
        return aName.localeCompare(bName);
      });
  };

  getFilteredAvailableEnterpriseUsers = () => {
    const { existingUserSearch } = this.state;
    const availableUsers = this.getAvailableEnterpriseUsers();
    if (!existingUserSearch) {
      return availableUsers;
    }
    const lowered = existingUserSearch.trim().toLowerCase();
    return availableUsers.filter((user) => {
      const email = (user.email_id || "").toLowerCase();
      const name = (user.full_name || user.display_name || "").toLowerCase();
      return email.includes(lowered) || name.includes(lowered);
    });
  };

  openAddUserModal = (mode = "existing") => {
    this.setState({
      addUserModalOpen: true,
      addUserMode: mode,
      existingUserSearch: "",
      selectedExistingUserId: null,
      modalError: "",
      inviteEmail: "",
      inviteHasAdminPrivileges: false,
      invitePasswordLoginDisabled: false,
      modalSubmitting: false,
    });
  };

  closeAddUserModal = () => {
    this.setState({
      addUserModalOpen: false,
      addUserMode: "existing",
      existingUserSearch: "",
      selectedExistingUserId: null,
      modalError: "",
      inviteEmail: "",
      inviteHasAdminPrivileges: false,
      invitePasswordLoginDisabled: false,
      modalSubmitting: false,
    });
  };

  handleExistingUserSelect = (userId) => {
    this.setState({
      selectedExistingUserId: userId,
      modalError: "",
    });
  };

  handleAddExistingUserSubmit = async () => {
    const { selectedExistingUserId, modalSubmitting } = this.state;
    if (modalSubmitting) {
      return;
    }
    if (!selectedExistingUserId) {
      this.setState({
        modalError: "Select a user to add to the group.",
      });
      return;
    }
    this.setState({ modalSubmitting: true, modalError: "" });
    try {
      await this.requestAddUserCall(selectedExistingUserId);
      this.setState({
        modalSubmitting: false,
        addUserModalOpen: false,
        selectedExistingUserId: null,
        existingUserSearch: "",
      });
    } catch (err) {
      this.setState({ modalSubmitting: false });
    }
  };

  handleCreateUserSubmit = async () => {
    const {
      inviteEmail,
      inviteHasAdminPrivileges,
      invitePasswordLoginDisabled,
      modalSubmitting,
    } = this.state;
    if (modalSubmitting) {
      return;
    }
    const trimmedEmail = (inviteEmail || "").trim();
    if (!trimmedEmail) {
      this.setState({
        modalError: "Enter an email address to invite a new user.",
      });
      return;
    }
    const enterpriseId = this.props.resources.userEnterprise?.id;
    if (!enterpriseId) {
      this.setState({
        modalError:
          "Enterprise information is still loading. Please try again shortly.",
      });
      return;
    }
    this.setState({ modalSubmitting: true, modalError: "" });
    try {
      const response = await axios.post(
        `/v1/enterprises/${enterpriseId}/users`,
        {
          email_id: trimmedEmail,
          has_admin_privileges: inviteHasAdminPrivileges,
          password_login_disabled: invitePasswordLoginDisabled,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      const createdUser = response?.data?.data;
      if (createdUser) {
        const existingUsers =
          this.props.resources.userEnterprise?.users || [];
        this.props.updateFetchWrapperState({
          userEnterprise: {
            ...this.props.resources.userEnterprise,
            users: [...existingUsers, createdUser],
          },
        });
      }
      const createdUserId = this.getUserIdentifier(createdUser);
      if (!createdUserId) {
        NotificationManager.alert(
          "The user was created but could not be added to the group automatically."
        );
        this.setState({
          modalSubmitting: false,
          addUserModalOpen: false,
          addUserMode: "existing",
          existingUserSearch: "",
          selectedExistingUserId: null,
          inviteEmail: "",
          inviteHasAdminPrivileges: false,
          invitePasswordLoginDisabled: false,
        });
        return;
      }
      await this.requestAddUserCall(createdUserId, {
        successMessage: "User invited and added to group",
      });
      this.setState({
        modalSubmitting: false,
        addUserModalOpen: false,
        addUserMode: "existing",
        existingUserSearch: "",
        selectedExistingUserId: null,
        inviteEmail: "",
        inviteHasAdminPrivileges: false,
        invitePasswordLoginDisabled: false,
      });
    } catch (err) {
      console.log(err);
      const message =
        err?.response?.data?.message ||
        "Unable to complete the request. Please try again.";
      this.setState({ modalSubmitting: false, modalError: message });
    }
  };

  renderAddUserModal = () => {
    if (!this.state.addUserModalOpen) {
      return null;
    }

    const {
      addUserMode,
      existingUserSearch,
      modalSubmitting,
      modalError,
      inviteEmail,
      inviteHasAdminPrivileges,
      invitePasswordLoginDisabled,
      selectedExistingUserId,
    } = this.state;
    const colors = getThemeColors(this.state.dark);
    const isExistingMode = addUserMode === "existing";
    const availableUsers = this.getAvailableEnterpriseUsers();
    const filteredAvailableUsers = this.getFilteredAvailableEnterpriseUsers();
    const selectedUser = availableUsers.find(
      (user) => this.getUserIdentifier(user) === selectedExistingUserId
    );
    const relevantDevices = this.getGroupDevices();
    const toggleOptions = [
      { key: "existing", label: "Existing member" },
      { key: "new", label: "Invite new user" },
    ];
    const sharedActionButtonStyle = {
      border: "none",
      borderRadius: "6px",
      padding: "10px 18px",
      fontWeight: 600,
      fontSize: "14px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
    };

    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: colors.overlay,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
          padding: "24px",
        }}
        onClick={() => {
          if (!modalSubmitting) {
            this.closeAddUserModal();
          }
        }}
      >
        <div
          style={{
            background: colors.surface,
            borderRadius: "12px",
            width: "min(760px, 100%)",
            maxHeight: "calc(100vh - 48px)",
            overflow: "hidden",
            boxShadow: "0 20px 50px rgba(15, 23, 42, 0.35)",
            display: "flex",
            flexDirection: "column",
            border: `1px solid ${colors.border}`,
          }}
          onClick={(event) => event.stopPropagation()}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              padding: "20px 24px",
              borderBottom: `1px solid ${colors.border}`,
              gap: "16px",
              background: colors.surface,
            }}
          >
            <div>
              <div
                style={{
                  fontWeight: 600,
                  fontSize: "18px",
                  color: colors.textPrimary,
                }}
              >
                Add a user to this group
              </div>
              <div style={{ color: colors.textSecondary, marginTop: "4px" }}>
                Choose an existing teammate or invite someone brand new.
              </div>
            </div>
            <button
              onClick={() => {
                if (!modalSubmitting) {
                  this.closeAddUserModal();
                }
              }}
              style={{
                background: "transparent",
                border: "none",
                color: colors.closeButton,
                fontSize: "20px",
                cursor: modalSubmitting ? "not-allowed" : "pointer",
                lineHeight: 1,
              }}
              aria-label="Close"
              type="button"
              disabled={modalSubmitting}
            >
              ×
            </button>
          </div>
          <div
            style={{
              padding: "0 24px 24px",
              overflowY: "auto",
              flex: 1,
              background: colors.surface,
            }}
          >
            <div
              style={{
                display: "inline-flex",
                border: `1px solid ${colors.borderMuted}`,
                borderRadius: "999px",
                padding: "4px",
                background: colors.surfaceMuted,
                marginBottom: "20px",
                marginTop: "24px",
                gap: "4px",
              }}
            >
              {toggleOptions.map((option) => {
                const isActive = addUserMode === option.key;
                return (
                  <button
                    key={option.key}
                    type="button"
                    onClick={() => {
                      if (!modalSubmitting) {
                        this.setState({
                          addUserMode: option.key,
                          modalError: "",
                        });
                      }
                    }}
                    style={{
                      border: "none",
                      borderRadius: "999px",
                      padding: "8px 18px",
                      fontWeight: 600,
                      fontSize: "13px",
                      cursor: modalSubmitting ? "not-allowed" : "pointer",
                      color: isActive ? "#fff" : colors.textMuted,
                      background: isActive ? "#1d4ed8" : "transparent",
                    }}
                  >
                    {option.label}
                  </button>
                );
              })}
            </div>

            {isExistingMode ? (
              <div>
                <TextInput
                  label="Search teammates"
                  placeholder="Search by name or email"
                  value={existingUserSearch}
                  callback={(value) =>
                    this.setState({ existingUserSearch: value })
                  }
                  inputContainerStyle={{ maxWidth: "420px" }}
                  disabled={modalSubmitting}
                />
                <div
                  style={{
                    border: `1px solid ${colors.border}`,
                    borderRadius: "8px",
                    marginTop: "12px",
                    maxHeight: "280px",
                    overflowY: "auto",
                    background: colors.surface,
                  }}
                >
                  {filteredAvailableUsers.length ? (
                    filteredAvailableUsers.map((user) => {
                      const identifier = this.getUserIdentifier(user);
                      const isSelected = identifier === selectedExistingUserId;
                      const pills = this.getUserStatusPills(user);
                      return (
                        <div
                          key={identifier}
                          onClick={() => {
                            if (!modalSubmitting) {
                              this.handleExistingUserSelect(identifier);
                            }
                          }}
                          style={{
                            padding: "12px 16px",
                            cursor: modalSubmitting ? "not-allowed" : "pointer",
                            background: isSelected
                              ? colors.selection
                              : colors.surface,
                            borderBottom: `1px solid ${colors.border}`,
                            }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: "12px",
                            }}
                          >
                            <div>
                              <div
                                style={{
                                  fontWeight: 600,
                                  color: colors.textPrimary,
                                }}
                              >
                                {user.full_name ||
                                  user.display_name ||
                                  user.email_id}
                              </div>
                              {user.full_name && user.email_id && (
                                <div
                                  style={{
                                    color: colors.textMuted,
                                    marginTop: "2px",
                                  }}
                                >
                                  {user.email_id}
                                </div>
                              )}
                            </div>
                            <div
                              style={{
                                width: "12px",
                                height: "12px",
                                borderRadius: "50%",
                                border: `2px solid ${
                                  isSelected ? colors.link : colors.borderMuted
                                }`,
                                background: isSelected ? colors.link : "transparent",
                              }}
                            />
                          </div>
                          {pills.length > 0 && (
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "6px",
                                marginTop: "10px",
                              }}
                            >
                              {pills.map((pill, pillIndex) => (
                                <span
                                  key={`${identifier}-pill-${pillIndex}`}
                                  style={{
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    padding: "3px 8px",
                                    borderRadius: "999px",
                                    color: pill.color,
                                    background: pill.background,
                                  }}
                                >
                                  {pill.label}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div
                      style={{
                        padding: "24px",
                        color: colors.textSecondary,
                        textAlign: "center",
                      }}
                    >
                      {availableUsers.length
                        ? "No teammates match your search."
                        : "All enterprise members are already in this group."}
                    </div>
                  )}
                </div>

                {selectedUser && (
                  <div
                    style={{
                      marginTop: "16px",
                      background: colors.surfaceMuted,
                      borderRadius: "8px",
                      padding: "12px 16px",
                      color: colors.textMuted,
                    }}
                  >
                    <div style={{ fontWeight: 600, color: colors.textPrimary }}>
                      {selectedUser.full_name ||
                        selectedUser.display_name ||
                        selectedUser.email_id}
                    </div>
                    <div style={{ marginTop: "6px" }}>
                      They will gain access to {relevantDevices.length}
                      {" "}
                      device{relevantDevices.length === 1 ? "" : "s"} tied to
                      this group.
                    </div>
                    {relevantDevices.length > 0 && (
                      <ul
                        style={{
                          marginTop: "8px",
                          paddingLeft: "18px",
                          maxHeight: "120px",
                          overflowY: "auto",
                        }}
                      >
                        {relevantDevices.map((device) => (
                          <li key={device.enclosureSerialNumber}>
                            {device.deviceName || "Device"} · {" "}
                            {device.enclosureSerialNumber}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    marginTop: "20px",
                  }}
                >
                  <button
                    type="button"
                    style={{
                      ...sharedActionButtonStyle,
                      backgroundColor: colors.buttonMutedBg,
                      color: colors.buttonMutedText,
                      cursor: modalSubmitting ? "not-allowed" : "pointer",
                    }}
                    onClick={() => {
                      if (!modalSubmitting) {
                        this.closeAddUserModal();
                      }
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    style={{
                      ...sharedActionButtonStyle,
                      backgroundColor: "#1d4ed8",
                      color: "#fff",
                      opacity:
                        modalSubmitting || !selectedExistingUserId ? 0.6 : 1,
                      cursor:
                        modalSubmitting || !selectedExistingUserId
                          ? "not-allowed"
                          : "pointer",
                    }}
                    onClick={this.handleAddExistingUserSubmit}
                  >
                    {modalSubmitting ? "Adding..." : "Add to group"}
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <TextInput
                  label="Work email"
                  placeholder="name@example.com"
                  value={inviteEmail}
                  callback={(value) => this.setState({ inviteEmail: value })}
                  disabled={modalSubmitting}
                  inputContainerStyle={{ maxWidth: "420px" }}
                />
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                    gap: "12px 24px",
                    marginTop: "8px",
                  }}
                >
                  <ToggleInput
                    label="Admin privileges"
                    value={inviteHasAdminPrivileges}
                    toggleLabelOff="No"
                    toggleLabelOn="Yes"
                    callback={(value) =>
                      this.setState({ inviteHasAdminPrivileges: value })
                    }
                    inputContainerStyle={{ marginBottom: 0 }}
                    disabled={modalSubmitting}
                  />
                  <ToggleInput
                    label="Password login allowed"
                    value={!invitePasswordLoginDisabled}
                    toggleLabelOff="No"
                    toggleLabelOn="Yes"
                    callback={(value) =>
                      this.setState({
                        invitePasswordLoginDisabled: !value,
                      })
                    }
                    inputContainerStyle={{ marginBottom: 0 }}
                    disabled={modalSubmitting}
                  />
                </div>

                <div
                  style={{
                    marginTop: "16px",
                    background: colors.surfaceMuted,
                    borderRadius: "8px",
                    padding: "12px 16px",
                    color: colors.textMuted,
                  }}
                >
                  <div style={{ fontWeight: 600, color: colors.textPrimary }}>
                    Group device access
                  </div>
                  <div style={{ marginTop: "6px" }}>
                    New members are automatically given access to this
                    group's {relevantDevices.length} device
                    {relevantDevices.length === 1 ? "" : "s"}.
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    marginTop: "20px",
                  }}
                >
                  <button
                    type="button"
                    style={{
                      ...sharedActionButtonStyle,
                      backgroundColor: colors.buttonMutedBg,
                      color: colors.buttonMutedText,
                      cursor: modalSubmitting ? "not-allowed" : "pointer",
                    }}
                    onClick={() => {
                      if (!modalSubmitting) {
                        this.closeAddUserModal();
                      }
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    style={{
                      ...sharedActionButtonStyle,
                      backgroundColor: "#1d4ed8",
                      color: "#fff",
                      opacity: modalSubmitting ? 0.6 : 1,
                      cursor: modalSubmitting ? "not-allowed" : "pointer",
                    }}
                    onClick={this.handleCreateUserSubmit}
                  >
                    {modalSubmitting ? "Sending invite..." : "Invite and add"}
                  </button>
                </div>
              </div>
            )}

            {modalError && (
              <div
                style={{
                  color: colors.destructiveText,
                  background: colors.destructiveBg,
                  marginTop: "16px",
                  fontWeight: 500,
                  padding: "10px 14px",
                  borderRadius: "6px",
                }}
              >
                {modalError}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  requestAddUserCall = (userId, options = {}) => {
    const { successMessage } = options || {};
    return axios
      .post(
        `/v1/groups/${this.props.match.params.groupId}/addUser`,
        {
          user_id: userId,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((data) => {
        NotificationManager.success(
          successMessage || "User added to group"
        );

        this.props.updateFetchWrapperState({
          groups: this.props.resources.groups.map((g) => {
            if (g.id == this.props.match.params.groupId) {
              return {
                ...g,
                users: [...g.users, data.data.data],
              };
            }
            return g;
          }),
        });
        return data.data.data;
      })
      .catch((e) => {
        console.log(e);
        NotificationManager.alert("Error adding user to group");
        throw e;
      });
  };
  requestRemoveUser = (userId) => {
    ModelManager.confirm(
      <div>
        <div>Are you sure you want to remove this user from the group?</div>
      </div>,
      "Remove User from Group",
      "Confirm",
      (status, close) => {
        if (status) {
          this.requestRemoveUserCall(userId, () => {
            close();
          });
        }
      }
    );
  };
  requestRemoveUserCall = (userId, cb = () => {}) => {
    axios
      .post(
        `/v1/groups/${this.props.match.params.groupId}/removeUser`,
        {
          // user_id: this.state.userToAdd,
          user_id: userId,
        },
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      )
      .then((data) => {
        NotificationManager.success("User removed from group");
        this.props.updateFetchWrapperState({
          groups: this.props.resources.groups.map((g) => {
            if (g.id == this.props.match.params.groupId) {
              const normalizedId = `${userId}`;
              return {
                ...g,
                users: g.users.filter(
                  (u) => `${this.getUserIdentifier(u)}` !== normalizedId
                ),
              };
            }
            return g;
          }),
        });
        cb();
      })
      .catch((e) => {
        console.log(e);
        NotificationManager.alert("Error removing user from group");
      });
  };

  getFilteredUsers = (groupUsers = []) => {
    const { searchTerm } = this.state;
    const normalizedUsers = groupUsers
      .map((user) => ({
        ...user,
        paginationId: `${this.getUserIdentifier(user)}`,
      }))
      .sort((a, b) => {
        const aIsAdmin = a.is_enterprise_admin || a.has_admin_privileges;
        const bIsAdmin = b.is_enterprise_admin || b.has_admin_privileges;
        if (aIsAdmin !== bIsAdmin) {
          return aIsAdmin ? -1 : 1;
        }
        return (a.email_id || "").localeCompare(b.email_id || "");
      });

    if (!searchTerm) {
      return normalizedUsers;
    }

    const lowered = searchTerm.trim().toLowerCase();
    return normalizedUsers.filter((user) => {
      const email = (user.email_id || "").toLowerCase();
      const name = (user.full_name || user.first_name || "").toLowerCase();
      return email.includes(lowered) || name.includes(lowered);
    });
  };

  handleUsersPageChange = (pageUsers = [], pager = null) => {
    this.setState({ usersPager: pager, usersPageItems: pageUsers });
  };

  getUserStatusPills = (user) => {
    const pills = [];
    const pillColors = getPillColors(this.state.dark);
    const isInactive =
      user.active === false || user.active_in_enterprise === false;
    if (isInactive) {
      pills.push({
        label: "Inactive",
        color: pillColors.inactive.color,
        background: pillColors.inactive.background,
      });
    } else {
      pills.push({
        label: "Active",
        color: pillColors.active.color,
        background: pillColors.active.background,
      });
    }

    if (user.approved === false) {
      pills.push({
        label: "Approval pending",
        color: pillColors.warning.color,
        background: pillColors.warning.background,
      });
    }

    if (user.email_verified === false) {
      pills.push({
        label: "Email not verified",
        color: pillColors.warning.color,
        background: pillColors.warning.background,
      });
    }

    if (user.password_login_disabled) {
      pills.push({
        label: "Password login disabled",
        color: pillColors.info.color,
        background: pillColors.info.background,
      });
    } else if (user.obscuredPassword === false) {
      pills.push({
        label: "Password not set",
        color: pillColors.neutral.color,
        background: pillColors.neutral.background,
      });
    }

    return pills;
  };

  renderUserRow = (user, index) => {
    const colors = getThemeColors(this.state.dark);
    const userIsAdmin =
      user.is_enterprise_admin || user.has_admin_privileges;
    const pills = this.getUserStatusPills(user);
    const displayName = user.full_name || user.display_name;
    const email = user.email_id;
    const identifier = this.getUserIdentifier(user);

    const loginSummary = user.password_login_disabled
      ? "SSO only"
      : user.obscuredPassword === false
      ? "Password not set"
      : "Password login enabled";

    const roleColor = userIsAdmin
      ? (this.state.dark ? "#bbf7d0" : "#065f46")
      : (this.state.dark ? "#bfdbfe" : "#1d4ed8");
    const roleBackground = userIsAdmin
      ? (this.state.dark ? "rgba(34, 197, 94, 0.22)" : "rgba(16, 185, 129, 0.14)")
      : (this.state.dark ? "rgba(96, 165, 250, 0.22)" : "rgba(29, 78, 216, 0.12)");

    return (
      <div
        key={user.paginationId || index}
        style={{
          display: "grid",
          gridTemplateColumns:
            "minmax(220px, 2.4fr) minmax(180px, 1.6fr) minmax(150px, 1fr) minmax(120px, 0.9fr) minmax(150px, 1fr)",
          gap: "16px",
          padding: "16px",
          borderTop: index === 0 ? "none" : `1px solid ${colors.border}`,
          alignItems: "flex-start",
          background: colors.surface,
        }}
      >
        <div>
          {/* <div
            style={{
              fontWeight: 600,
              fontSize: "15px",
              color: "#111827",
              wordBreak: "break-word",
            }}
          >
            {displayName || email || "Unknown user"}
          </div> */}
          {email && (
            <div
              style={{
                color: colors.textPrimary,
                marginTop: "4px",
                fontWeight: 600,
                fontSize: "15px",
              }}
            >
              <Link
                to={`/team/members/${user.user_id}`}
                style={{
                  textDecoration: "underline",
                  color: colors.link,
                  wordBreak: "break-all",
                }}
              >
                {email}
              </Link>
            </div>
          )}
          {/* <div style={{ color: "#6b7280", marginTop: "6px", fontSize: "12px" }}>
            User ID: {identifier}
          </div> */}
        </div>

        <div>
          {pills.length > 0 ? (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "6px",
              }}
            >
              {pills.map((pill, pillIndex) => (
                <span
                  key={`${user.paginationId}-pill-${pillIndex}`}
                  style={{
                    fontSize: "11px",
                    fontWeight: 600,
                    padding: "4px 9px",
                    borderRadius: "999px",
                    color: pill.color,
                    background: pill.background,
                  }}
                >
                  {pill.label}
                </span>
              ))}
            </div>
          ) : (
            <div style={{ color: colors.textFaint, fontSize: "12px" }}>—</div>
          )}
        </div>

        <div style={{ color: colors.textMuted, fontSize: "13px" }}>{loginSummary}</div>

        <div>
          <span
            style={{
              fontSize: "12px",
              fontWeight: 600,
              color: roleColor,
              background: roleBackground,
              padding: "4px 10px",
              borderRadius: "999px",
              textTransform: "uppercase",
              letterSpacing: "0.04em",
              whiteSpace: "nowrap",
            }}
          >
            {userIsAdmin ? "Admin" : "Member"}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <Link
            to={`/team/members/${user.user_id}`}
            style={{
              fontSize: "12px",
              color: colors.link,
              textDecoration: "underline",
              fontWeight: 600,
              alignSelf: "center",
            }}
          >
            View profile
          </Link>
          {!userIsAdmin && (
            <button
              type="button"
              onClick={() => {
                this.requestRemoveUser(identifier);
              }}
              style={{
                border: "none",
                borderRadius: "6px",
                padding: "8px 14px",
                fontSize: "12px",
                fontWeight: 600,
                backgroundColor: colors.destructiveBg,
                color: colors.destructiveText,
                cursor: "pointer",
              }}
            >
              Remove
            </button>
          )}
        </div>
      </div>
    );
  };

  render() {
    if (!this.props.resources.userEnterpriseLoaded) {
      return <Loading />;
    }

    const foundGroup = this.props.resources.groups.find(
      (g) => g.id == this.props.match.params.groupId
    );
    if (!foundGroup) {
      return null;
    }

    const colors = getThemeColors(this.state.dark);
    const filteredUsers = this.getFilteredUsers(foundGroup?.users || []);
    const { usersPager, usersPageItems } = this.state;
    const totalUsers = filteredUsers.length;
    const pageSize = usersPager?.pageSize || 10;
    const showingStart = totalUsers === 0
      ? 0
      : (usersPager ? usersPager.startIndex + 1 : 1);
    const showingEnd = totalUsers === 0
      ? 0
      : (usersPager
          ? Math.min(usersPager.endIndex + 1, totalUsers)
          : Math.min(pageSize, totalUsers));
    const currentPageUsers = usersPageItems.length
      ? usersPageItems
      : filteredUsers.slice(0, Math.min(pageSize, filteredUsers.length));
    const columnTemplate =
      "minmax(220px, 2.4fr) minmax(180px, 1.6fr) minmax(150px, 1fr) minmax(120px, 0.9fr) minmax(150px, 1fr)";

    return (
      <div className="grid-x">
        {this.renderAddUserModal()}
        <div className="cell large-12">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingTop: "20px",
              gap: "16px",
            }}
          >
            <div>
              <h4 style={{ marginBottom: "4px" }}>Group Users</h4>
              <div style={{ color: colors.textMuted }}>
                Manage which team members can access this device group.
              </div>
            </div>
            <div>
              <span
                className="button"
                onClick={() => {
                  this.openAddUserModal();
                }}
                style={{ marginBottom: "0px" }}
              >
                Add User
              </span>
            </div>
          </div>

          <div
            style={{
              marginTop: "18px",
              display: "flex",
              flexWrap: "wrap",
              gap: "16px",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <TextInput
              label="Search users"
              placeholder="Search by name or email"
              value={this.state.searchTerm}
              callback={(value) => this.setState({ searchTerm: value })}
              inputContainerStyle={{ maxWidth: "360px", marginBottom: 0 }}
            />
            <div style={{ color: colors.textSecondary, fontSize: "14px" }}>
              {totalUsers === 0
                ? "Showing 0 of 0 members"
                : `Showing ${showingStart}-${showingEnd} of ${totalUsers} members`}
            </div>
          </div>

          <div style={{ marginTop: "24px" }}>
            {filteredUsers.length ? (
              <div style={{ overflowX: "auto" }}>
                <div
                  style={{
                    minWidth: "820px",
                    border: `1px solid ${colors.border}`,
                    borderRadius: "3px",
                    overflow: "hidden",
                    background: colors.surface,
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: columnTemplate,
                      gap: "16px",
                      padding: "12px 16px",
                      background: colors.surfaceMuted,
                      color: colors.textMuted,
                      fontSize: "11px",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}
                  >
                    <div>User</div>
                    <div>Status</div>
                    <div>Login</div>
                    <div>Role</div>
                    <div style={{ textAlign: "right" }}>Actions</div>
                  </div>
                  {currentPageUsers.map((user, index) =>
                    this.renderUserRow(user, index)
                  )}
                </div>
                <div style={{ marginTop: "16px" }}>
                  <Pagination
                    items={filteredUsers}
                    renderItem={() => null}
                    onPageChange={this.handleUsersPageChange}
                  />
                </div>
              </div>
            ) : (
            <div
              style={{
                border: `1px dashed ${colors.borderMuted}`,
                padding: "32px",
                borderRadius: "10px",
                textAlign: "center",
                color: colors.textSecondary,
              }}
            >
                {this.state.searchTerm
                  ? "No users match your search."
                  : "No users have been added to this group yet. Use the Add User button to get started."}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

class GroupSettings extends React.Component {
  state = {
    name: "",
    description: "",
    loading: false,
    hasChanges: false,
  };

  componentDidMount() {
    this.hydrateFromResources();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.resources.groups !== this.props.resources.groups ||
      prevProps.match.params.groupId !== this.props.match.params.groupId
    ) {
      this.hydrateFromResources();
    }
  }

  hydrateFromResources = () => {
    const isNew = this.props.match.params.groupId === "new";
    if (isNew) {
      return;
    }

    const foundGroup = this.props.resources.groups.find(
      (g) => g.id == this.props.match.params.groupId
    );

    if (foundGroup && !this.state.hasChanges) {
      this.setState({
        name: foundGroup.name || "",
        description: foundGroup.description || "",
      });
    }
  };

  removeGroup = () => {
    ModelManager.confirm(
      "This action will permanently delete this group.",
      "Remove Group",
      "Remove",
      (submitted, close) => {
        if (submitted) {
          this.props.removeResource(
            "groups",
            this.props.match.params.groupId,
            () => {
              this.props.history.push("/devices/groups");
              close && close();
            }
          );
        }
      }
    );
  };

  onSave = () => {
    if (this.state.loading) {
      return;
    }

    const isNew = this.props.match.params.groupId === "new";

    this.setState({ loading: true });

    const payload = {
      name: this.state.name,
      groupType: "devices",
      description: this.state.description,
    };

    if (isNew) {
      this.props.createResource("groups", payload, (err, newGroup) => {
        this.setState({ loading: false });
        if (newGroup) {
          this.props.history.push(`/devices/groups/${newGroup.id}`);
        }
      });
    } else {
      this.props.modifyResource(
        "groups",
        this.props.match.params.groupId,
        payload,
        (err, updatedGroup) => {
          this.setState({
            loading: false,
            hasChanges: !updatedGroup ? this.state.hasChanges : false,
          });
        }
      );
    }
  };

  onCancel = () => {
    const isNew = this.props.match.params.groupId === "new";

    if (!this.state.hasChanges) {
      return;
    }

    const resetChanges = () => {
      if (isNew) {
        this.setState({ name: "", description: "", hasChanges: false });
      } else {
        const foundGroup = this.props.resources.groups.find(
          (g) => g.id == this.props.match.params.groupId
        );
        this.setState({
          name: foundGroup?.name || "",
          description: foundGroup?.description || "",
          hasChanges: false,
        });
      }
    };

    ModelManager.confirm(
      "You have unsaved changes. Are you sure you want to cancel?",
      "Confirm Cancel",
      "Discard",
      (status, close) => {
        if (status) {
          resetChanges();
          close && close();
        }
      }
    );
  };

  render() {
    const isNew = this.props.match.params.groupId === "new";
    const { hasChanges, loading, name, description } = this.state;

    return (
      <div className="device-group-settings-page">
        <div className="device-group-settings-page__header">
          <div>
            <h2 className="device-group-settings-page__title">
              {isNew ? "Create device group" : "Group settings"}
            </h2>
            <p className="device-group-settings-page__subtitle">
              {isNew
                ? "Name your device group and describe how it will be used so the rest of your team can find it quickly."
                : "Update the details that team members see when they open this device group. Changes are saved for everyone."}
            </p>
          </div>
          <div className="device-group-settings-page__actions">
            <button
              type="button"
              className="device-group-settings__button device-group-settings__button--ghost"
              onClick={this.onCancel}
              disabled={!hasChanges}
            >
              Cancel
            </button>
            <button
              type="button"
              className="device-group-settings__button device-group-settings__button--primary"
              onClick={this.onSave}
              disabled={loading || !name?.trim()}
            >
              {loading ? <Loading /> : isNew ? "Create group" : "Save changes"}
            </button>
          </div>
        </div>
        <div className="device-group-settings-page__content">
          <section className="device-group-settings-card">
            <div className="device-group-settings-card__header">
              <h3>Group details</h3>
              <p>
                Set the name and description that appear on group dashboards,
                search results, and automation rules.
              </p>
            </div>
            <div className="device-group-settings-card__body">
              <TextInput
                label="Group name"
                value={name}
                placeholder="Example: Lab PDUs"
                callback={(value) => {
                  this.setState({
                    name: value,
                    hasChanges: true,
                  });
                }}
                inputContainerStyle={{ marginBottom: "20px" }}
              />
              <TextInput
                label="Group description"
                value={description}
                placeholder="Share context so teammates know what belongs here."
                callback={(value) => {
                  this.setState({
                    description: value,
                    hasChanges: true,
                  });
                }}
                inputContainerStyle={{ marginBottom: "0" }}
              />
            </div>
          </section>

          {!isNew && (
            <section className="device-group-settings-card device-group-settings-card--danger">
              <div className="device-group-settings-card__header">
                <h3>Danger zone</h3>
                <p>
                  Deleting a group immediately removes device associations and
                  any related automation. This cannot be undone.
                </p>
              </div>
              <div className="device-group-settings-card__body">
                <button
                  type="button"
                  className="device-group-settings__button device-group-settings__button--danger"
                  onClick={this.removeGroup}
                >
                  Delete group permanently
                </button>
              </div>
            </section>
          )}
        </div>
      </div>
    );
  }
}

class GroupPrivileges extends React.Component {
  state = {
    roleId: "",

    roles: [],
  };
  componentDidMount() {
    if (
      !this.props.resources.rolesLoaded &&
      !this.props.resources.rolesLoading
    ) {
      this.props.fetchResource("roles");
    } else {
      const foundGroup = this.props.resources.groups.find(
        (g) => g.id == this.props.match.params.groupId
      );
      if (foundGroup) {
        this.setState({ roleId: foundGroup.role_id });
      }
    }
  }
  componentDidUpdate = (prevProps) => {
      if (this.props.resources.rolesLoaded && !prevProps.resources.rolesLoaded) {
          const foundRole = this.props.resources.roles.find(role => role.id == this.props.match.params.roleId);
          if (foundRole) {
              this.setState({roleId: foundRole.id})
          }
      }
  }
  processRoleChange = (roleId) => {
    if (roleId === "create-new-role") {
      this.props.history.push("/users/roles/new");
    } else {
      ModalManager.confirm(
        "Are you sure you want to assign this role to the group? All users in this group will have the permissions described in this role.",
        "Confirm Role Assignment",
        "Confirm",
        (status, close) => {
          if (status) {
            this.props.modifyResource(
              "groups",
              this.props.match.params.groupId,
              {
                role_id: roleId,
              },
              (err, res) => {
                if (res) {
                  this.setState({
                    roleId,
                  })
                  close && close();
                }
              }
            )
          }
        }
      )
    }
  };

  render() {
    const foundGroup = this.props.resources.groups.find(
      (g) => g.id == this.props.match.params.groupId
    );
    if (!foundGroup) {
      return null;
    }
    const foundRole = this.props.resources.roles.find(
      (r) => r.id == foundGroup.role_id
    );
    const roles = this.props.resources.roles;
    return (
      <div>
        <div className="grid-x">
          <div className="cell">
            <div style={{ padding: "20px", paddingBottom: "0px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "20px",
              }}
            ></div>
            <h4>Role Assignment for Group</h4>
            <div>
              <div style={{ marginBottom: "10px" }}>
                Assign a role to this group. All users in this group will have the privileges described in this role. If no role is assigned, users in this group will have full privileges.
              </div>
            </div>
            <div>
              <SelectInput
                label="Role Assigned"
                value={this.state.roleId}
                callback={this.processRoleChange}
                defaultSelectText="Select a role"
                options={[
                  {
                    label: "No Role",
                    value: "",
                  },
                  ...roles.map((r) => ({
                    value: r.id,
                    label: r.name,
                  })),
                  {
                    label: "+ Create New Role",
                    value: "create-new-role",
                  },
                ]}
              />
            </div>

            </div>

            {foundRole &&
              <div
                style={{
                  padding: "20px",
                  fontFamily: "Arial, sans-serif",
                  color: "#333",
                }}
              >
                <div
                  style={{
                    borderBottom: "1px solid #bbb",
                    marginBottom: "20px",
                    paddingBottom: "10px",
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <h4 style={{ margin: 0 }}>Role Details</h4>
                  <div>
                      <div className="button" style={{ marginBottom: "0px" }}> 
                        <Link
                          to={`/users/roles/${foundRole.id}`}
                          style={{ color: "white" }}
                        >
                          Edit Role
                        </Link>
                      </div>
                  </div>
                </div>

                <div style={{ marginBottom: "15px" }}>
                  <div style={{ display: "flex", marginBottom: "10px" }}>
                    <div style={{ fontWeight: "bold", width: "150px" }}>
                      Name:
                    </div>
                    <div>{foundRole.name}</div>
                  </div>

                  <div style={{ display: "flex", marginBottom: "10px" }}>
                    <div style={{ fontWeight: "bold", width: "150px" }}>
                      Description:
                    </div>
                    <div>{foundRole.description}</div>
                  </div>
                </div>

                <div style={{ borderTop: "1px solid #bbb", paddingTop: "10px" }}>
                  <div style={{ marginBottom: "5px", fontWeight: "bold", marginTop: "10px" }}>
                    Permissions
                  </div>
                  <div style={{ paddingBottom: "20px" }}>
                    Permissions apply to all users in this group. Users will have access to the devices in this group, and the accompany permissions/privileges described in this role. Users may also be assigned roles at the user level along with the group level. Permissions are additive.
                  </div>
                  <div className={`grid-row header`}>
                    <div style={{ flex: 3 }}>Privilege</div>
                    <div style={{ flex: 2 }}>Status</div>
                    <div style={{ flex: 15 }}>Description</div>
                  </div>
                  {[{
                    label: "Basic Device Privileges",
                    permissions: [{
                      //   title: "View device info",
                      //   field: "viewDeviceInfo",
                      //   description: "View device information such as device name, model, connection state, and other basic device info"
                      // }, {
                        title: "Edit device info",
                        field: "editDeviceInfo",
                        description: "Edit device information such as device name and various configurations. Unpair devices."
                      }]
                  }, {
                    label: "Inlet & Power Privileges",
                    permissions: [{
                      title: "View inlet info",
                      field: "viewInletInfo",
                      description: "View inlet information such as inlet name, state, power, and other inlet info"
                    }, {
                      title: "Edit inlet info",
                      field: "editInletInfo",
                      description: "Edit inlet information such as inlet name, inlet boot states, reboot intervals, and other inlet specific info"
                    }, {
                      title: "View sensor accessory info",
                      field: "viewSensorInfo",
                      description: "View sensor information such as temperature and humidity readings, names, etc."
                    }]
                  }, {
                    label: "Outlet Privileges",
                    permissions: [{
                        title: "View all outlets",
                        field: "viewAllOutletsAllowed",
                        description: "View all outlet information such as outlet name, state, power, and other outlet info"
                      }, {
                        title: "Edit all outlets",
                        field: "editAllOutletsAllowed",
                        description: "Edit all outlet information such as outlet name, outlet boot states, reboot intervals, and other outlet specific info"
                      }, {
                        title: "Switch all outlets",
                        field: "switchAllOutletsAllowed",
                        description: "Switch outlets ON, OFF, or power cycle outlets"
                      }]
                  }, {
                    label: "Event & Activity Privileges",
                    permissions: [{
                        title: "View activity",
                        field: "viewActivityLog",
                        description: "View activity logs and history for the device group"
                      }, {
                        title: "View events & actions",
                        field: "viewEventInfo",
                        description: "View events and alerts for the device group"
                      }, {
                        title: "Create, edit, and delete events & actions",
                        field: "editEventInfo",
                        description: "Manage events and alerts for the device group"
                      }]
                  }].map((section => {
                    return (
                        <div>
                            <div style={{ marginTop: "15px" }}>
                            {/* {section.label} */}

                                <div className={`grid-row header`}>
                                    <div style={{ flex: 3 }}>{section.label}</div>
                                    <div style={{ flex: 3 }}></div>
                                    <div style={{ flex: 15 }}></div>
                                </div>
                            </div>
                            {section.permissions.map((item) => {
                            return (
                              <div className={`grid-row`}>
                              <div style={{ flex: 3 }}>{item.title}</div>
                              <div style={{ flex: 2, color: foundRole[item.field] ? "#222" : "#777" }}>
                                {foundRole[item.field] ? "Allowed" : "Not Allowed"}
                              </div>
                              <div style={{ flex: 15, color: "#444", fontStyle: "italic" }}>{item.description}</div>
                            </div>
                            );
                            })}
                        </div>
                        );
                  }))}
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}


// ...existing code for DeviceGroupPage, GroupUsers, GroupSettings, GroupPrivileges

class FakeDataCollectionPage extends React.Component {
  state = {
    // Mocks for demonstration
    dataMeasurements: [
      {
        timestamp: "2025-03-01T08:00:00Z",
        labBenchName: "Test Bench: A01-A02",
        groupName: "Asgard Lab",
        groupId: "926472",
        outletNumber: 1,
        equipmentId: "EQ-1001",
        equipmentName: "Oscilloscope",
        currentRms: 0.12,
        voltage: 120,
        state: "ON",
      },
      {
        timestamp: "2025-03-02T10:15:00Z",
        labBenchName: "Test Bench: A01-A02",
        groupName: "Asgard Lab",
        groupId: "926472",
        outletNumber: 2,
        equipmentId: "EQ-5555",
        equipmentName: "Multimeter",
        currentRms: 0.02,
        voltage: 120,
        state: "ON",
      },
      {
        timestamp: "2025-03-05T14:30:00Z",
        labBenchName: "Test Bench: A01-A02",
        groupName: "Asgard Lab",
        groupId: "926472",
        outletNumber: 3,
        equipmentId: "EQ-1002",
        equipmentName: "Oscilloscope",
        currentRms: 0.12,
        voltage: 120,
        state: "ON",
      },
      // ...
    ],

    // Date range
    startDate: "",
    endDate: "",
  };

  /**
   * Filters the data based on the selected date range.
   */
  getFilteredMeasurements = () => {
    const { dataMeasurements, startDate, endDate } = this.state;
    if (!dataMeasurements || dataMeasurements.length === 0) return [];

    // If no date range is chosen, return all
    if (!startDate && !endDate) {
      return dataMeasurements;
    }

    // Convert input date strings to actual Date objects
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    return dataMeasurements.filter((measurement) => {
      const timestamp = new Date(measurement.timestamp);
      // Check startDate <= timestamp <= endDate
      if (start && timestamp < start) return false;
      if (end && timestamp > end) return false;
      return true;
    });
  };

  /**
   * Builds a CSV string from the filtered data.
   */
  generateCsvData = () => {
    const filteredData = this.getFilteredMeasurements();
    if (filteredData.length === 0) return "";

    const headers = [
      "timestamp",
      "labBenchName",
      "groupName",
      "groupId",
      "outletNumber",
      "equipmentId",
      "equipmentName",
      "currentRms",
      "voltage",
      "state",
    ];

    const rows = filteredData.map((m) => [
      m.timestamp,
      m.labBenchName,
      m.groupName,
      m.groupId,
      m.outletNumber,
      m.equipmentId,
      m.equipmentName,
      m.currentRms,
      m.voltage,
      m.state,
    ]);

    const csvContent = [
      headers.join(","), 
      ...rows.map((row) => row.join(",")),
    ].join("\n");
    return csvContent;
  };

  /**
   * Builds a JSON string from the filtered data.
   */
  generateJsonData = () => {
    const filteredData = this.getFilteredMeasurements();
    return JSON.stringify(filteredData, null, 2); // pretty-print
  };

  /**
   * Allows the user to download the CSV file.
   */
  downloadCsv = () => {
    const csvContent = this.generateCsvData();
    if (!csvContent) {
      alert("No data available for the selected date range.");
      return;
    }

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", "dataCollection.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  /**
   * Allows the user to download the JSON file.
   */
  downloadJson = () => {
    const jsonContent = this.generateJsonData();
    if (!jsonContent) {
      alert("No data available for the selected date range.");
      return;
    }

    const blob = new Blob([jsonContent], { type: "application/json" });
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", "dataCollection.json");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  handleStartDateChange = (e) => {
    this.setState({ startDate: e.target.value });
  };

  handleEndDateChange = (e) => {
    this.setState({ endDate: e.target.value });
  };

  render() {
    const filteredMeasurements = this.getFilteredMeasurements();

    return (
      <div style={{ padding: "20px" }}>
        <h3>Data Collection</h3>
        <p>
          These measurements include the lab bench name, the group (lab location),
          outlet number, the connected equipment (with an ID and name), current
          RMS, voltage, and outlet state, plus a timestamp for when the
          measurement was taken. Typically, each lab bench PDU gathers data from
          24 outlets, each with a new entry every minute.
        </p>


        {/* Example table showing the (filtered) mock data */}
        <div style={{ maxHeight: "200px", overflow: "auto", marginBottom: "20px" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "10px",
            }}
          >
            <thead>
              <tr>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Timestamp</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Lab Bench</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Lab/Location</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Lab ID</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Outlet #</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Equipment ID</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Equipment Name</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Current (RMS)</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>Voltage</th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "5px" }}>State</th>
              </tr>
            </thead>
            <tbody>
              {filteredMeasurements.map((m, i) => (
                <tr key={i}>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.timestamp}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.labBenchName}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.groupName}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.groupId}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.outletNumber}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.equipmentId}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.equipmentName}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.currentRms}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.voltage}
                  </td>
                  <td style={{ borderBottom: "1px solid #eee", padding: "5px" }}>
                    {m.state}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Download Buttons */}
        <div style={{ marginBottom: "20px" }}>

        {/* Date Range Filters */}
        <div style={{ marginBottom: "20px" }}>
          <label style={{  }}>
            Start Date:
            <input
              type="date"
              value={this.state.startDate}
              onChange={this.handleStartDateChange}
              style={{ marginLeft: "5px" }}
            />
          </label>
          <label style={{  }}>
            End Date:
            <input
              type="date"
              value={this.state.endDate}
              onChange={this.handleEndDateChange}
              style={{ marginLeft: "5px" }}
            />
          </label>
        </div>
          <button className="button" onClick={this.downloadCsv}>
            Download CSV
          </button>
          <button
            className="button"
            onClick={this.downloadJson}
            style={{ marginLeft: "10px" }}
          >
            Download JSON
          </button>
        </div>

        <h4>Accessing Data via HTTP Endpoint</h4>
        <p>
          You can also retrieve this data programmatically through our
          HTTP endpoint at:
        </p>
        <code style={{ display: "block", marginBottom: "10px" }}>
          GET /v1/data/{"<<lab_bench_id>>"}/measurements
        </code>
        <p>
          Replace {"<<lab_bench_id>>"} with the appropriate bench or group identifier.
          Make sure to include your API token in the request headers.
        </p>

        <h4>Connecting Directly to the SQL Database</h4>
        <p>
          For advanced data consumption or large-scale analytics, you can directly
          connect to our database by following the instructions here:
        </p>
        <a
          href="/docs/sql-connection"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "underline" }}
        >
          Connect to SQL Database
        </a>
      </div>
    );
  }
}



// ...export and the rest of the file remain intact
